export const processImages = images => (images?.length > 0 ? images.map(item => item.imageUrl).filter(Boolean) : []);

export const findImageId = (imgUrl, array) => {
  return array.find(item => item.imageUrl === imgUrl)?.imageId;
};

export const findImagesByType = (images, type) =>
  images?.length > 0 ? images.filter(({imageType}) => imageType === type) : [];

export const findUsedImage = images => (images?.length > 0 ? images.filter(({isUsed}) => isUsed) : []);

export const findUsedImageByType = (images, type) =>
  images?.length > 0 ? images.filter(({imageType, isUsed}) => imageType === type && isUsed) : [];
